import React from "react";
import CardCourse from "../components/CardCourse";
import { courses } from "../data/courses";

function Courses() {
  return (
    <div className="container max-w-7xl mx-auto px-4 py-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 tracking-tight mb-8">
        Danh Sách Khóa Học
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {courses.map((course) => (
          <CardCourse
            key={course.id}
            course={course}
            isAdmin={false}
          />
        ))}
      </div>
    </div>
  );
}

export default Courses;